import React from "react";
import styles from "./CardItemSmall.module.css";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import toVND from "shared/func/toVND";
import history from "core/helper/Helper";
import { RouterName } from "shared/RouterName";

const CardItemSmall = (props) => {
  const { id, imgPath, title, price, priceDiscount, discount } = props;

  const handelClick = () => {
    history.push(`${RouterName.ProductDetail.url}/${id}`);
  };
  return (
    <div className={styles.container}>
      <Card className={styles.card_container}>
        <CardActionArea onClick={handelClick}>
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              sm={6}
              className={styles.img_card_small_container}
              style={{ backgroundImage: `url(${imgPath})` }}
            ></Grid>

            <Grid item xs={12} sm={6} className={styles.content}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={styles.title}
              >
                {title.length > 30 ? `${title.slice(0, 30)}...` : title}
              </Typography>

              <Typography
                variant="body1"
                color="textSecondary"
                component="p"
                className={styles.price_last}
              >
                {!price
                  ? "Liên hệ"
                  : priceDiscount
                  ? toVND(priceDiscount)
                  : toVND(price)}
              </Typography>

              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                className={styles.price_first}
              >
                {priceDiscount ? toVND(price) : null}
              </Typography>

              <Typography
                variant="overline"
                display="inline"
                gutterBottom
                className={styles.discount}
              >
                {priceDiscount ? discount : null}
              </Typography>
            </Grid>
          </Grid>
        </CardActionArea>
      </Card>
    </div>
  );
};

export default CardItemSmall;
